/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../inputs/selector-control/selector-control.component.ngfactory';
import * as import2 from '../../inputs/selector-control/selector-control.component';
import * as import3 from '../../buttons/button/button.component.ngfactory';
import * as import4 from '../../buttons/button/button.component';
import * as import5 from '../../orchestration/session.model';
import * as import6 from '../../orchestration/responsive.service';
import * as import7 from '../../page-layout/page-footer-control.directive';
import * as import8 from '../../page-layout/modal-page-layout/modal-page-layout.component.ngfactory';
import * as import9 from '../../page-layout/modal-page-layout/modal-page-layout.component';
import * as import10 from '../../orchestration/page';
import * as import11 from '../../orchestration/navigation.service';
import * as import12 from '@angular/common';
import * as import13 from './simple-dialog-page.component';
import * as import14 from '../../orchestration/navigation-params';
const styles_SimpleDialogPageComponent:any[] = ([] as any[]);
export const RenderType_SimpleDialogPageComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_SimpleDialogPageComponent,
  data: {}
}
);
function View_SimpleDialogPageComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-selector-control',[[
        'class',
        'simple-dialog-checkbox'
      ]
    ],[
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'touched',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'selectedChange'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('selectedChange' === en)) {
        const pd_0:any = ((<any>(co.checkboxState[v.context.$implicit.name] = $event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import1.View_SelectorControlComponent_0,import1.RenderType_SelectorControlComponent)),
    import0.ɵdid(49152,(null as any),0,import2.SelectorControlComponent,([] as any[]),{
      selected: [
        0,
        'selected'
      ]
      ,
      label: [
        1,
        'label'
      ]
      ,
      translationParams: [
        2,
        'translationParams'
      ]

    }
    ,{selectedChange: 'selectedChange'})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_2:any = co.checkboxState[v.context.$implicit.name];
    const currVal_3:any = v.context.$implicit.label;
    const currVal_4:any = co.translationParams;
    ck(v,1,0,currVal_2,currVal_3,currVal_4);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).disabled;
    const currVal_1:any = import0.ɵnov(v,1).touched;
    ck(v,0,0,currVal_0,currVal_1);
  });
}
function View_SimpleDialogPageComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-button',[[
        'woa-page-footer-control',
        ''
      ]
    ],[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.dismiss(v.context.$implicit.result)) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import3.View_ButtonComponent_0,import3.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import4.ButtonComponent,[
      import0.ElementRef,
      import5.SessionModel,
      import0.ChangeDetectorRef,
      import6.ResponsiveService
    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      translationParams: [
        1,
        'translationParams'
      ]
      ,
      tier: [
        2,
        'tier'
      ]
      ,
      prominence: [
        3,
        'prominence'
      ]
      ,
      connotation: [
        4,
        'connotation'
      ]

    }
    ,(null as any)),
      import0.ɵdid(16384,[[
        3,
        4
      ]
    ],0,import7.PageFooterControlDirective,([] as any[]),(null as any),(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_27:any = v.context.$implicit.label;
    const currVal_28:any = co.translationParams;
    const currVal_29:any = co.ButtonTier.FIRST;
    const currVal_30:any = co.ButtonProminence.HIGH;
    const currVal_31:any = v.context.$implicit.connotation;
    ck(v,1,0,currVal_27,currVal_28,currVal_29,currVal_30,currVal_31);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).overrideFlatBackgroundColor;
    const currVal_1:any = import0.ɵnov(v,1).overrideFlatForegroundColor;
    const currVal_2:any = import0.ɵnov(v,1).overrideOutlineBackgroundColor;
    const currVal_3:any = import0.ɵnov(v,1).overrideOutlineForegroundColor;
    const currVal_4:any = import0.ɵnov(v,1).overrideOutlineBorderColor;
    const currVal_5:any = import0.ɵnov(v,1).overrideRaisedBackgroundColor;
    const currVal_6:any = import0.ɵnov(v,1).overrideRaisedForegroundColor;
    const currVal_7:any = import0.ɵnov(v,1).disabled;
    const currVal_8:any = import0.ɵnov(v,1).invisible;
    const currVal_9:any = import0.ɵnov(v,1).hovered;
    const currVal_10:any = import0.ɵnov(v,1).native;
    const currVal_11:any = import0.ɵnov(v,1).button;
    const currVal_12:any = import0.ɵnov(v,1).firstTier;
    const currVal_13:any = import0.ɵnov(v,1).secondTier;
    const currVal_14:any = import0.ɵnov(v,1).highProminence;
    const currVal_15:any = import0.ɵnov(v,1).lowProminence;
    const currVal_16:any = import0.ɵnov(v,1).affirmativeConnotation;
    const currVal_17:any = import0.ɵnov(v,1).dissuasiveConnotation;
    const currVal_18:any = import0.ɵnov(v,1).negativeConnotation;
    const currVal_19:any = import0.ɵnov(v,1).squareShape;
    const currVal_20:any = import0.ɵnov(v,1).roundedShape;
    const currVal_21:any = import0.ɵnov(v,1).ovalShape;
    const currVal_22:any = import0.ɵnov(v,1).flatStyle;
    const currVal_23:any = import0.ɵnov(v,1).outlineStyle;
    const currVal_24:any = import0.ɵnov(v,1).raisedStyle;
    const currVal_25:any = import0.ɵnov(v,1).verticalLayout;
    const currVal_26:any = import0.ɵnov(v,1).horizontalLayout;
    ck(v,0,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26
    ]
    );
  });
}
export function View_SimpleDialogPageComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵqud(402653184,1,{pageLayout: 0}),
    (l()(),import0.ɵeld(0,(null as any),(null as any),11,'woa-modal-page-layout',([] as any[]),(null as any),(null as any),(null as any),import8.View_ModalPageLayoutComponent_0,import8.RenderType_ModalPageLayoutComponent)),
    import0.ɵdid(114688,(null as any),2,import9.ModalPageLayoutComponent,[
      import10.Page,
      import11.NavigationService
    ]
    ,{
      showHeader: [
        0,
        'showHeader'
      ]
      ,
      showCloseButton: [
        1,
        'showCloseButton'
      ]
      ,
      title: [
        2,
        'title'
      ]
      ,
      subtitle: [
        3,
        'subtitle'
      ]
      ,
      translationParams: [
        4,
        'translationParams'
      ]
      ,
      contentText: [
        5,
        'contentText'
      ]
      ,
      showContent: [
        6,
        'showContent'
      ]
      ,
      footerControlOrientation: [
        7,
        'footerControlOrientation'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,2,{contentMessages: 1}),
    import0.ɵqud(603979776,3,{footerControls: 1}),
      import0.ɵprd(2048,[[
        1,
        4
      ]
    ],import10.PageLayout,(null as any),[import9.ModalPageLayoutComponent]),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),4,1,(null as any),View_SimpleDialogPageComponent_1)),
    import0.ɵdid(802816,(null as any),0,import12.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),7,1,(null as any),View_SimpleDialogPageComponent_2)),
    import0.ɵdid(802816,(null as any),0,import12.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import13.SimpleDialogPageComponent = v.component;
    const currVal_0:any = co.showHeader;
    const currVal_1:any = co.showCloseButton;
    const currVal_2:any = co.title;
    const currVal_3:any = co.subtitle;
    const currVal_4:any = co.translationParams;
    const currVal_5:any = co.contentText;
    const currVal_6:boolean = (!!co.contentText || (co.checkboxes.length > 0));
    const currVal_7:any = ((co.buttons.length <= 2)? 'horizontal': 'vertical');
    ck(v,2,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
    const currVal_8:any = co.checkboxes;
    ck(v,8,0,currVal_8);
    const currVal_9:any = co.buttons;
    ck(v,11,0,currVal_9);
  },(null as any));
}
function View_SimpleDialogPageComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-simple-dialog-page',([] as any[]),(null as any),(null as any),(null as any),View_SimpleDialogPageComponent_0,RenderType_SimpleDialogPageComponent)),
    import0.ɵdid(49152,(null as any),0,import13.SimpleDialogPageComponent,[
      import14.NavigationParams,
      import11.NavigationService
    ]
    ,(null as any),(null as any)),
    import0.ɵprd(6144,(null as any),import10.Page,(null as any),[import13.SimpleDialogPageComponent])
  ]
  ,(null as any),(null as any));
}
export const SimpleDialogPageComponentNgFactory:import0.ComponentFactory<import13.SimpleDialogPageComponent> = import0.ɵccf('woa-simple-dialog-page',import13.SimpleDialogPageComponent,View_SimpleDialogPageComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/notification/simple-dialog-page/simple-dialog-page.component.ngfactory.ts